<template>
  <div class="justify-left flex w-full">
    <component
      :is="data.component"
      v-on="data.eventHandlers || {}"
      v-bind="data.props as typeof data.component.props"
    />
  </div>
</template>

<script lang="ts">
import type { Entity } from "@/enums/entityProfiles";
import type { IProfile } from "@/models/businesses";
import type { IUser, RoleIdentifier } from "@/models/users";
import type { PropType } from "vue";

interface Props {
  modelValue?: PropType<IUser | string | number | null>;
  model?: IApplication | Partial<IProfile>;
  type?: string | Entity;
  roleIdentifier?: RoleIdentifier;
}
</script>
<script setup lang="ts">
import { computed, ref, watch } from "vue";

import AssignUserForEntityProfile from "@/components/entityProfiles/profiles/AssignUserForEntityProfile.vue";
import AssignUserDropdown from "@/views/deals/components/AssignUserDropdown.vue";

import type { IApplication } from "@/models/applications";

const props = defineProps<Props>();

const modelValueRef = ref(props.modelValue);
const modelRef = ref(props.model);

const data = computed(() =>
  props.roleIdentifier
    ? {
        component: AssignUserForEntityProfile,
        eventHandlers: {
          changed: (value: Partial<IProfile>) => {
            modelRef.value = value;
          },
        },
        props: {
          profile: modelRef.value,
          type: props.type,
          "role-identifier": props.roleIdentifier,
        },
      }
    : {
        component: AssignUserDropdown,
        props: {
          "app-id": props.model?.id,
          "client-id": (props.model as IApplication)?.client?.id,
          type: props.type,
          modelValue: modelValueRef.value,
          classes: "py-1 px-1 h-[26px]",
        },
      }
);

watch(
  () => props.modelValue,
  (value) => {
    modelValueRef.value = value;
  }
);

watch(
  () => props.model,
  (value) => {
    modelRef.value = value;
  }
);
</script>
